import { ThemeLayerConfig } from '../../themeLayerConfigApi';

export const tilgjengelighetConfig: ThemeLayerConfig = {
  categories: [
    {
      id: 'tilgjengelighet',
      groupid: 11,
      name: {
        nb: 'Tilgjengelighet',
        nn: 'Tilgjengelegheit',
        en: 'Accessibility',
      },
      wmsUrl: 'https://wms.geonorge.no/skwms1/wms.tilgjengelighet3',
      infoFormat: 'application/vnd.ogc.gml',
      featureInfoImageBaseUrl:
        'https://data.kartverket.no/tilgjengelighet/tilgjengelighet',
      featureInfoFields: [
        {
          name: 'tilgjengvurderingrulleauto',
          type: 'symbol',
          alias: 'Rullestol',
          baseurl:
            'https://data.kartverket.no/tilgjengelighet/symboler/rullestol/',
          filetype: 'png',
        },
        {
          name: 'tilgjengvurderingelrullestol',
          type: 'symbol',
          alias: 'El-rullestol',
          baseurl:
            'https://data.kartverket.no/tilgjengelighet/symboler/rullestol_el/',
          filetype: 'png',
        },
        {
          name: 'tilgjengvurderingelrull',
          type: 'symbol',
          alias: 'El-rullestol',
          baseurl:
            'https://data.kartverket.no/tilgjengelighet/symboler/rullestol_el/',
          filetype: 'png',
        },
        {
          name: 'tilgjengvurderingsyn',
          type: 'symbol',
          alias: 'Syn',
          baseurl: 'https://data.kartverket.no/tilgjengelighet/symboler/syn/',
          filetype: 'png',
        },
        {
          name: 'bildefil1',
          type: 'picture',
          alias: 'Bilde 1',
          baseurl:
            'https://data.kartverket.no/tilgjengelighet/tilgjengelighet/',
        },
        {
          name: 'bildefil2',
          type: 'picture',
          alias: 'Bilde 2',
          baseurl:
            'https://data.kartverket.no/tilgjengelighet/tilgjengelighet/',
        },
        {
          name: 'bildefil3',
          type: 'picture',
          alias: 'Bilde 3',
          baseurl:
            'https://data.kartverket.no/tilgjengelighet/tilgjengelighet/',
        },
        {
          name: 'linkskjema',
          type: 'link',
          alias: 'Skjema',
          baseurl:
            'https://data.kartverket.no/tilgjengelighet/friluft-skjema-FRL-2012/',
        },
        {
          name: 'linkbilde',
          type: 'link',
          alias: 'Bilde (lenke)',
          baseurl:
            'https://data.kartverket.no/tilgjengelighet/friluft-skjema-FRL-2012/',
        },
        {
          name: 'lenke',
          type: 'link',
          alias: 'Lenke',
          baseurl: '',
        },
        {
          name: 'forstedatafangstdato',
          alias: 'Registrert',
        },
        {
          name: 'datafangstdato',
          alias: 'Oppdatert',
        },
        {
          name: 'navn',
          alias: 'Navn',
        },
        {
          name: 'eier',
          alias: 'Eier',
        },
        {
          name: 'gatetype',
          alias: 'Gatetype',
        },
        {
          name: 'spesialfotrutetype',
          alias: 'Spesial fotrutetype',
        },
        {
          name: 'dekkemateriale',
          alias: 'Dekke material',
        },
        {
          name: 'plankeavstand',
          alias: 'Plankeavstand',
          unit: 'cm',
        },
        {
          name: 'dekketilstand',
          alias: 'Dekke tilstand',
        },
        {
          name: 'dekkefasthet',
          alias: 'Dekke fasthet',
        },
        {
          name: 'bredde',
          alias: 'Bredde',
          unit: 'cm',
        },
        {
          name: 'lengde',
          alias: 'Lengde',
          unit: 'cm',
        },
        {
          name: 'gatelangsparkering',
          alias: 'Gatelangsparkering',
        },
        {
          name: 'tryggovergang',
          alias: 'Trygg overgang',
        },
        {
          name: 'brukbartbetjeningsareal',
          alias: 'Brukbart betjeningsareal',
        },
        {
          name: 'automathoyde',
          alias: 'Automat høyde',
          unit: 'cm',
        },
        {
          name: 'adkomstkant',
          alias: 'Adkomst kant',
        },
        {
          name: 'adkomsttilgjengelig',
          alias: 'Adkomst tilgjengelig',
        },
        {
          name: 'helning',
          alias: 'Helning',
        },
        {
          name: 'hoydebenk',
          alias: 'Høyde benk',
        },
        {
          name: 'armlene',
          alias: 'Armlene',
        },
        {
          name: 'ryggstotte',
          alias: 'Ryggstøtte',
        },
        {
          name: 'hoydebord',
          alias: 'Høyde bord',
        },
        {
          name: 'utstikkbord',
          alias: 'Utstikk bord',
        },
        {
          name: 'oppstillingsplass',
          alias: 'Oppstillingsplass',
        },
        {
          name: 'byggtype',
          alias: 'Byggtype',
        },
        {
          name: 'servanttilgjengelig',
          alias: 'Servant tilgjengelig',
        },
        {
          name: 'wctilgjengelig',
          alias: 'WC tilgjengelig',
        },
        {
          name: 'omkledningtilgjengelig',
          alias: 'Omkledning tilgjengelig',
        },
        {
          name: 'belysninginne',
          alias: 'Belysning inne',
        },
        {
          name: 'stigning',
          alias: 'Stigning',
          unit: '°',
        },
        {
          name: 'tverrfall',
          alias: 'Tverrfall',
          unit: '°',
        },
        {
          name: 'belysning',
          alias: 'Belysning',
        },
        {
          name: 'varmekabel',
          alias: 'Varmekabel',
        },
        {
          name: 'frihoyde',
          alias: 'Fri høyde',
        },
        {
          name: 'ledelinje',
          alias: 'Ledelinje',
        },
        {
          name: 'ledelinjekontrast',
          alias: 'Ledelinje kontrast',
        },
        {
          name: 'nedsenk1',
          alias: 'Nedsenk 1',
        },
        {
          name: 'nedsenk2',
          alias: 'Nedsenk 2',
        },
        {
          name: 'trapp',
          alias: 'Trapp',
        },
        {
          name: 'trappkontrast',
          alias: 'Trapp kontrast',
        },
        {
          name: 'trappenesekontrast',
          alias: 'Trappenesekontrast',
        },
        {
          name: 'opptrinn',
          alias: 'Opptrinn',
        },
        {
          name: 'inntrinn',
          alias: 'Inntrinn',
        },
        {
          name: 'horisontalfelt',
          alias: 'Horisontalt felt',
        },
        {
          name: 'dortype',
          alias: 'Dørtype',
        },
        {
          name: 'dorapner',
          alias: 'Døråpner',
        },
        {
          name: 'manoverknapphoyde',
          alias: 'Manøverknapp høyde',
        },
        {
          name: 'ringeklokke',
          alias: 'Ringeklokke',
        },
        {
          name: 'ringeklokkehoyde',
          alias: 'Ringeklokke høyde',
        },
        {
          name: 'kontrastinngang',
          alias: 'Kontrast inngang',
        },
        {
          name: 'kommentar',
          alias: 'Kommentar',
        },
        {
          name: 'lokalid',
          alias: 'Lokal ID',
        },
        {
          name: 'rampe',
          alias: 'Rampe',
        },
        {
          name: 'rampebredde',
          alias: 'Rampe bredde',
          unit: 'cm',
        },
        {
          name: 'rampelengde',
          alias: 'Rampelengde',
          unit: 'cm',
        },
        {
          name: 'rampestigning',
          alias: 'Rampe stigning',
          unit: '°',
        },
        {
          name: 'rampeterskel',
          alias: 'Rampe terskel',
          unit: 'cm',
        },
        {
          name: 'rampetilgjengelig',
          alias: 'Rampe tilgjengelig',
        },
        {
          name: 'handlist',
          alias: 'Håndlist',
        },
        {
          name: 'handlisthoydeovre',
          alias: 'Håndlist høyde øvre',
          unit: 'cm',
        },
        {
          name: 'handlisthoydenedre',
          alias: 'Håndlist høyde nedre',
          unit: 'cm',
        },
        {
          name: 'diameter',
          alias: 'Diameter',
          unit: 'cm',
        },
        {
          name: 'breddeinngang',
          alias: 'Inngang bredde',
          unit: 'cm',
        },
        {
          name: 'hoydeinngang',
          alias: 'Inngang høyde',
          unit: 'cm',
        },
        {
          name: 'terskelhoyde',
          alias: 'Terskel høyde',
          unit: 'cm',
        },
        {
          name: 'flytebrygge',
          alias: 'Flytebrygge',
        },
        {
          name: 'rekkverk',
          alias: 'Rekkverk',
        },
        {
          name: 'farefeltovert',
          alias: 'Farefelt øvert',
        },
        {
          name: 'oppmerksamhetsfeltnederst',
          alias: 'Oppmerksomhetsfelt nederst',
        },
        {
          name: 'stoppkant',
          alias: 'Stoppkant',
        },
        {
          name: 'stoppkanthoyde',
          alias: 'Stoppkant høyde',
          unit: 'cm',
        },
        {
          name: 'skiltet',
          alias: 'Skiltet',
        },
        {
          name: 'merket',
          alias: 'Merket',
        },
        {
          name: 'avstandservicebygg',
          alias: 'Avstand servicebygg',
          unit: 'm',
        },
        {
          name: 'bredde_hc',
          alias: 'Bredde HC',
          unit: 'cm',
        },
        {
          name: 'lengde_hc',
          alias: 'Lengde HC',
          unit: 'cm',
        },
        {
          name: 'avgift',
          alias: 'Avgift',
        },
        {
          name: 'hoyde_kantsten',
          alias: 'Høyde kantsten',
          unit: 'cm',
        },
        {
          name: 'tilgjengeligautomat',
          alias: 'Tilgjengelig automat',
        },
        {
          name: 'kapasitetpersonbiler',
          alias: 'Kapasitet personbiler',
        },
        {
          name: 'antalluu',
          alias: 'Antall UU',
        },
        {
          name: 'naturbaseid',
          alias: 'Naturbase ID',
        },
        {
          name: 'hcparkeringsplass',
          alias: 'HC-parkeringsplass',
        },
        {
          name: 'toalett',
          alias: 'Toalett',
        },
        {
          name: 'turvei',
          alias: 'Turveg',
        },
        {
          name: 'baderampe',
          alias: 'Baderampe',
        },
        {
          name: 'fiskeplass',
          alias: 'Fiskeplass',
        },
        {
          name: 'grillbalplass',
          alias: 'Grillbålplass',
        },
        {
          name: 'sittegruppebenk',
          alias: 'Sittegruppe',
        },
        {
          name: 'gapahuk',
          alias: 'Gapahuk',
        },
        {
          name: 'informasjon',
          alias: 'Informasjon',
        },
        {
          name: 'sperrebom',
          alias: 'Sperrebom',
        },
        {
          name: 'sperrebomtilgjengelig',
          alias: 'Sperrebom tilgjengelig',
        },
        {
          name: 'dobbelspor',
          alias: 'Dobbelspor',
        },
        {
          name: 'forbedringsforslag',
          alias: 'Forbedringsforslag',
        },
        {
          name: 'plasstype',
          alias: 'Plasstype',
        },
      ],
    },
    {
      id: 'accessibilityVillageWheelchair',
      groupid: 6,
      name: {
        nb: 'Tettsted - Rullestol',
        nn: 'Tettstad - Rullestol',
        en: 'Village - Wheelchair',
      },
      wmsUrl: 'https://wms.geonorge.no/skwms1/wms.tilgjengelighet3',
      parentId: 'tilgjengelighet',
    },
    {
      id: 'accessibilityVillageElectricWheelchair',
      groupid: 9,
      name: {
        nb: 'Tettsted - El-rullestol',
        nn: 'Tettstad - El-rullestol',
        en: 'Village - Electric wheelchair',
      },
      wmsUrl: 'https://wms.geonorge.no/skwms1/wms.tilgjengelighet3',
      parentId: 'tilgjengelighet',
    },
    {
      id: 'accessibilityVillageSight',
      groupid: 8,
      name: {
        nb: 'Tettsted - Synshemninger',
        nn: 'Tettstad - Synshemmingar',
        en: 'Village - Sight',
      },
      wmsUrl: 'https://wms.geonorge.no/skwms1/wms.tilgjengelighet3',
      parentId: 'tilgjengelighet',
    },
    {
      id: 'accessibilityRecreationWheelchair',
      groupid: 5,
      name: {
        nb: 'Friluft - Rullestol',
        nn: 'Friluft - Rullestol',
        en: 'Recreation - Wheelchair',
      },
      wmsUrl: 'https://wms.geonorge.no/skwms1/wms.tilgjengelighet3',
      parentId: 'tilgjengelighet',
    },
    {
      id: 'accessibilityRecreationElectricWheelchair',
      groupid: 7,
      name: {
        nb: 'Friluft - El-rullestol',
        nn: 'Friluft - El-rullestol',
        en: 'Recreation - Electric wheelchair',
      },
      wmsUrl: 'https://wms.geonorge.no/skwms1/wms.tilgjengelighet3',
      parentId: 'tilgjengelighet',
    },
    {
      id: 'accessibilityRecreationSight',
      groupid: 3,
      name: {
        nb: 'Friluft - Syn',
        nn: 'Friluft - Syn',
        en: 'Recreation - Sight',
      },
      wmsUrl: 'https://wms.geonorge.no/skwms1/wms.tilgjengelighet3',
      parentId: 'tilgjengelighet',
    },
    {
      id: 'accessibilityShared',
      groupid: 10,
      name: {
        nb: 'Felles',
        nn: 'Felles',
        en: 'Shared',
      },
      wmsUrl: 'https://wms.geonorge.no/skwms1/wms.tilgjengelighet3',
      parentId: 'tilgjengelighet',
    },
  ],
  layers: [
    {
      id: '6_t_parkeringsomrade_r',
      name: {
        nb: 'Parkeringsområde',
        nn: 'Parkeringsområde',
        en: 'Parking area',
      },
      layers: 't_parkeringsomrade_r',
      categoryId: 'accessibilityVillageWheelchair',
      groupid: 6,
      legacyId: 'Tilgjengelighet.1011',
      queryable: true,
    },
    {
      id: '6_t_vei_r',
      name: {
        nb: 'Veg',
        nn: 'Veg',
        en: 'Road',
      },
      layers: 't_vei_r',
      categoryId: 'accessibilityVillageWheelchair',
      groupid: 6,
      legacyId: 'Tilgjengelighet.1012',
      queryable: true,
    },
    {
      id: '6_t_HC_parkering_r',
      name: {
        nb: 'HC-parkering',
        nn: 'Handikapp-parkering  ',
        en: 'HC-parking',
      },
      layers: 't_HC_parkering_r',
      categoryId: 'accessibilityVillageWheelchair',
      groupid: 6,
      legacyId: 'Tilgjengelighet.1013',
      queryable: true,
      useLegendGraphic: true,
    },
    {
      id: '6_t_inngangbygg_r_01',
      name: {
        nb: 'Inngang bygg',
        nn: 'Inngang bygg',
        en: 'Bulding entrance',
      },
      layers: 't_inngangbygg_r_01',
      categoryId: 'accessibilityVillageWheelchair',
      groupid: 6,
      legacyId: 'Tilgjengelighet.1014',
      queryable: true,
    },
    {
      id: '9_t_parkeringsomrade_el',
      name: {
        nb: 'Parkeringsområde',
        nn: 'Parkeringsområde',
        en: 'Parking area',
      },
      layers: 't_parkeringsomrade_el',
      categoryId: 'accessibilityVillageElectricWheelchair',
      groupid: 9,
      legacyId: 'Tilgjengelighet.1015',
      queryable: true,
    },
    {
      id: '9_t_vei_el',
      name: {
        nb: 'Veg',
        nn: 'Veg',
        en: 'Road',
      },
      layers: 't_vei_el',
      categoryId: 'accessibilityVillageElectricWheelchair',
      groupid: 9,
      legacyId: 'Tilgjengelighet.1016',
      queryable: true,
    },
    {
      id: '9_t_HC_parkering_el',
      name: {
        nb: 'HC-parkering',
        nn: 'Handikapp-parkering  ',
        en: 'HC-parking',
      },
      layers: 't_HC_parkering_el',
      categoryId: 'accessibilityVillageElectricWheelchair',
      groupid: 9,
      legacyId: 'Tilgjengelighet.1017',
      queryable: true,
      useLegendGraphic: true,
    },
    {
      id: '9_t_inngangbygg_r_02',
      name: {
        nb: 'Inngang bygg',
        nn: 'Inngang bygg',
        en: 'Bulding entrance',
      },
      layers: 't_inngangbygg_r_02',
      categoryId: 'accessibilityVillageElectricWheelchair',
      groupid: 9,
      legacyId: 'Tilgjengelighet.1018',
      queryable: true,
    },
    {
      id: '8_t_parkeringsomrade',
      name: {
        nb: 'Parkeringsområde',
        nn: 'Parkeringsområde',
        en: 'Parking area',
      },
      layers: 't_parkeringsomrade',
      categoryId: 'accessibilityVillageSight',
      groupid: 8,
      legacyId: 'Tilgjengelighet.1019',
      queryable: true,
    },
    {
      id: '8_t_vei',
      name: {
        nb: 'Veg',
        nn: 'Veg',
        en: 'Road',
      },
      layers: 't_vei',
      categoryId: 'accessibilityVillageSight',
      groupid: 8,
      legacyId: 'Tilgjengelighet.1020',
      queryable: true,
    },
    {
      id: '8_t_HC_parkering',
      name: {
        nb: 'HC-parkering',
        nn: 'Handikapp-parkering  ',
        en: 'HC-parking',
      },
      layers: 't_HC_parkering',
      categoryId: 'accessibilityVillageSight',
      groupid: 8,
      legacyId: 'Tilgjengelighet.1021',
      queryable: true,
      useLegendGraphic: true,
    },
    {
      id: '8_t_inngangbygg',
      name: {
        nb: 'Inngang bygg',
        nn: 'Inngang bygg',
        en: 'Bulding entrance',
      },
      layers: 't_inngangbygg',
      categoryId: 'accessibilityVillageSight',
      groupid: 8,
      legacyId: 'Tilgjengelighet.1022',
      queryable: true,
    },
    {
      id: '5_friluftsomrade_01',
      name: {
        nb: 'Friluftsområde',
        nn: 'Friluftsområde',
        en: 'Recreational area',
      },
      layers: 'friluftsomrade_01',
      categoryId: 'accessibilityRecreationWheelchair',
      groupid: 5,
      legacyId: 'Tilgjengelighet.1024',
      queryable: true,
    },
    {
      id: '5_parkeringsomrader_friluft_01',
      name: {
        nb: 'Parkeringsområder',
        nn: 'Parkeringsområde',
        en: 'Parking areas',
      },
      layers: 'parkeringsomrader_friluft_01',
      categoryId: 'accessibilityRecreationWheelchair',
      groupid: 5,
      legacyId: 'Tilgjengelighet.1025',
      queryable: true,
    },
    {
      id: '5_turvei_01',
      name: {
        nb: 'Turveg',
        nn: 'Turveg',
        en: 'Hiking path',
      },
      layers: 'turvei_01',
      categoryId: 'accessibilityRecreationWheelchair',
      groupid: 5,
      legacyId: 'Tilgjengelighet.1026',
      queryable: true,
    },
    {
      id: '5_turisthytte_01',
      name: {
        nb: 'Turisthytte',
        nn: 'Turisthytte',
        en: 'Tourist cabin',
      },
      layers: 'turisthytte_01',
      categoryId: 'accessibilityRecreationWheelchair',
      groupid: 5,
      legacyId: 'Tilgjengelighet.1027',
      queryable: true,
      useLegendGraphic: true,
    },
    {
      id: '5_gapahukhytte_01',
      name: {
        nb: 'Gapahuk',
        nn: 'Gapahuk',
        en: 'Lean-to shelter',
      },
      layers: 'gapahukhytte_01',
      categoryId: 'accessibilityRecreationWheelchair',
      groupid: 5,
      legacyId: 'Tilgjengelighet.1028',
      queryable: true,
      useLegendGraphic: true,
    },
    {
      id: '5_fiskeplass_01',
      name: {
        nb: 'Fiskeplass',
        nn: 'Fiskeplass',
        en: 'Fishing spot',
      },
      layers: 'fiskeplass_01',
      categoryId: 'accessibilityRecreationWheelchair',
      groupid: 5,
      legacyId: 'Tilgjengelighet.1029',
      queryable: true,
      useLegendGraphic: true,
    },
    {
      id: '5_grillbalplass_01',
      name: {
        nb: 'Grillbålplass',
        nn: 'Grillbålplass',
        en: 'BBQ fire pit',
      },
      layers: 'grillbalplass_01',
      categoryId: 'accessibilityRecreationWheelchair',
      groupid: 5,
      legacyId: 'Tilgjengelighet.1030',
      queryable: true,
      useLegendGraphic: true,
    },
    {
      id: '5_baderampe_01',
      name: {
        nb: 'Baderampe',
        nn: 'Baderampe',
        en: 'Swiming accessibility ramp',
      },
      layers: 'baderampe_01',
      categoryId: 'accessibilityRecreationWheelchair',
      groupid: 5,
      legacyId: 'Tilgjengelighet.1031',
      queryable: true,
      useLegendGraphic: true,
    },
    {
      id: '5_hc_parkering_friluft_01',
      name: {
        nb: 'HC-parkering',
        nn: 'Handikapp-parkering  ',
        en: 'HC-parking',
      },
      layers: 'hc_parkering_friluft_01',
      categoryId: 'accessibilityRecreationWheelchair',
      groupid: 5,
      legacyId: 'Tilgjengelighet.1032',
      queryable: true,
      useLegendGraphic: true,
    },
    {
      id: '5_skiloype_01',
      name: {
        nb: 'Skiløype',
        nn: 'Skiløype',
        en: 'Cross country skiing route',
      },
      layers: 'skiloype_01',
      categoryId: 'accessibilityRecreationWheelchair',
      groupid: 5,
      legacyId: 'Tilgjengelighet.1033',
      queryable: true,
    },
    {
      id: '7_friluftsomrade_02',
      name: {
        nb: 'Friluftsområde',
        nn: 'Friluftsområde',
        en: 'Recreational area',
      },
      layers: 'friluftsomrade_02',
      categoryId: 'accessibilityRecreationElectricWheelchair',
      groupid: 7,
      legacyId: 'Tilgjengelighet.1023',
      queryable: true,
    },
    {
      id: '7_parkeringsomrader_friluft_02',
      name: {
        nb: 'Parkeringsområder',
        nn: 'Parkeringsområde',
        en: 'Parking areas',
      },
      layers: 'parkeringsomrader_friluft_02',
      categoryId: 'accessibilityRecreationElectricWheelchair',
      groupid: 7,
      legacyId: 'Tilgjengelighet.1024',
      queryable: true,
    },
    {
      id: '7_turvei_02',
      name: {
        nb: 'Turveg',
        nn: 'Turveg',
        en: 'Hiking path',
      },
      layers: 'turvei_02',
      categoryId: 'accessibilityRecreationElectricWheelchair',
      groupid: 7,
      legacyId: 'Tilgjengelighet.1025',
      queryable: true,
    },
    {
      id: '7_turisthytte_02',
      name: {
        nb: 'Turisthytte',
        nn: 'Turisthytte',
        en: 'Tourist cabin',
      },
      layers: 'turisthytte_02',
      categoryId: 'accessibilityRecreationElectricWheelchair',
      groupid: 7,
      legacyId: 'Tilgjengelighet.1026',
      queryable: true,
      useLegendGraphic: true,
    },
    {
      id: '7_gapahukhytte_02',
      name: {
        nb: 'Gapahuk',
        nn: 'Gapahuk',
        en: 'Lean-to shelter',
      },
      layers: 'gapahukhytte_02',
      categoryId: 'accessibilityRecreationElectricWheelchair',
      groupid: 7,
      legacyId: 'Tilgjengelighet.1027',
      queryable: true,
      useLegendGraphic: true,
    },
    {
      id: '7_fiskeplass_02',
      name: {
        nb: 'Fiskeplass',
        nn: 'Fiskeplass',
        en: 'Fishing spot',
      },
      layers: 'fiskeplass_02',
      categoryId: 'accessibilityRecreationElectricWheelchair',
      groupid: 7,
      legacyId: 'Tilgjengelighet.1028',
      queryable: true,
      useLegendGraphic: true,
    },
    {
      id: '7_grillbalplass_02',
      name: {
        nb: 'Grillbålplass',
        nn: 'Grillbålplass',
        en: 'BBQ fire pit',
      },
      layers: 'grillbalplass_02',
      categoryId: 'accessibilityRecreationElectricWheelchair',
      groupid: 7,
      legacyId: 'Tilgjengelighet.1029',
      queryable: true,
      useLegendGraphic: true,
    },
    {
      id: '7_hc_parkering_friluft_02',
      name: {
        nb: 'HC-parkering',
        nn: 'Handikapp-parkering  ',
        en: 'HC-parking',
      },
      layers: 'hc_parkering_friluft_02',
      categoryId: 'accessibilityRecreationElectricWheelchair',
      groupid: 7,
      legacyId: 'Tilgjengelighet.1030',
      queryable: true,
      useLegendGraphic: true,
    },
    {
      id: '7_skiloype_02',
      name: {
        nb: 'Skiløype',
        nn: 'Skiløype',
        en: 'Cross country skiing route',
      },
      layers: 'skiloype_02',
      categoryId: 'accessibilityRecreationElectricWheelchair',
      groupid: 7,
      legacyId: 'Tilgjengelighet.1031',
      queryable: true,
    },
    {
      id: '3_friluftsomrade_03',
      name: {
        nb: 'Friluftsområde',
        nn: 'Friluftsområde',
        en: 'Recreational area',
      },
      layers: 'friluftsomrade_03',
      categoryId: 'accessibilityRecreationSight',
      groupid: 3,
      legacyId: 'Tilgjengelighet.1033',
      queryable: true,
    },
    {
      id: '3_parkeringsomrader_friluft_03',
      name: {
        nb: 'Parkeringsområder',
        nn: 'Parkeringsområde',
        en: 'Parking areas',
      },
      layers: 'parkeringsomrader_friluft_03',
      categoryId: 'accessibilityRecreationSight',
      groupid: 3,
      legacyId: 'Tilgjengelighet.1034',
      queryable: true,
    },
    {
      id: '3_turvei_03',
      name: {
        nb: 'Turveg',
        nn: 'Turveg',
        en: 'Hiking path',
      },
      layers: 'turvei_03',
      categoryId: 'accessibilityRecreationSight',
      groupid: 3,
      legacyId: 'Tilgjengelighet.1035',
      queryable: true,
    },
    {
      id: '3_turisthytte_03',
      name: {
        nb: 'Turisthytte',
        nn: 'Turisthytte',
        en: 'Tourist cabin',
      },
      layers: 'turisthytte_03',
      categoryId: 'accessibilityRecreationSight',
      groupid: 3,
      legacyId: 'Tilgjengelighet.1036',
      queryable: true,
      useLegendGraphic: true,
    },
    {
      id: '3_gapahukhytte_03',
      name: {
        nb: 'Gapahuk',
        nn: 'Gapahuk',
        en: 'Lean-to shelter',
      },
      layers: 'gapahukhytte_03',
      categoryId: 'accessibilityRecreationSight',
      groupid: 3,
      legacyId: 'Tilgjengelighet.1037',
      queryable: true,
      useLegendGraphic: true,
    },
    {
      id: '3_fiskeplass_03',
      name: {
        nb: 'Fiskeplass',
        nn: 'Fiskeplass',
        en: 'Fishing spot',
      },
      layers: 'fiskeplass_03',
      categoryId: 'accessibilityRecreationSight',
      groupid: 3,
      legacyId: 'Tilgjengelighet.1038',
      queryable: true,
      useLegendGraphic: true,
    },
    {
      id: '3_grillbalplass_03',
      name: {
        nb: 'Grillbålplass',
        nn: 'Grillbålplass',
        en: 'BBQ fire pit',
      },
      layers: 'grillbalplass_03',
      categoryId: 'accessibilityRecreationSight',
      groupid: 3,
      legacyId: 'Tilgjengelighet.1039',
      queryable: true,
      useLegendGraphic: true,
    },
    {
      id: '3_baderampe_02',
      name: {
        nb: 'Baderampe',
        nn: 'Baderampe',
        en: 'Swiming accessibility ramp',
      },
      layers: 'baderampe_02',
      categoryId: 'accessibilityRecreationSight',
      groupid: 3,
      legacyId: 'Tilgjengelighet.1040',
      queryable: true,
      useLegendGraphic: true,
    },
    {
      id: '3_hc_parkering_friluft_03',
      name: {
        nb: 'HC-parkering',
        nn: 'Handikapp-parkering  ',
        en: 'HC-parking',
      },
      layers: 'hc_parkering_friluft_03',
      categoryId: 'accessibilityRecreationSight',
      groupid: 3,
      legacyId: 'Tilgjengelighet.1041',
      queryable: true,
      useLegendGraphic: true,
    },
    {
      id: '3_skiloype_03',
      name: {
        nb: 'Skiløype',
        nn: 'Skiløype',
        en: 'Cross country skiing route',
      },
      layers: 'skiloype_03',
      categoryId: 'accessibilityRecreationSight',
      groupid: 3,
      legacyId: 'Tilgjengelighet.1042',
      queryable: true,
    },
    {
      id: '10_toalett',
      name: {
        nb: 'Toalett',
        nn: 'Toalett',
        en: 'Toilet',
      },
      layers: 'toalett',
      categoryId: 'accessibilityShared',
      groupid: 10,
      legacyId: 'Tilgjengelighet.1055',
      queryable: true,
      useLegendGraphic: true,
    },
    {
      id: '10_sittegruppebenk',
      name: {
        nb: 'Sittegruppebenk',
        nn: 'Sitjegruppebenk',
        en: 'Seating',
      },
      layers: 'sittegruppebenk',
      categoryId: 'accessibilityShared',
      groupid: 10,
      legacyId: 'Tilgjengelighet.1056',
      queryable: true,
      useLegendGraphic: true,
    },
  ],
};
